import { createSelector } from './selectorWrapper'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { pageSelectors } from './basicState'

export const notificationWarningsSelector = createSelector(
  pageSelectors.notification,
  (notification?: WpsRuntime.atv.wps.NotificationFragmentModelProps) => notification && notification.warnings
)

export const notificationAlertsSelector = createSelector(
  pageSelectors.notification,
  (notification?: WpsRuntime.atv.wps.NotificationFragmentModelProps) => notification && notification.alerts
)

export const comingSoonMessagesPresentSelector = createSelector(
  [pageSelectors.notification],
  (notification?: WpsRuntime.atv.wps.NotificationFragmentModelProps) => {
    return (
      notification && notification.alerts.some(alert => alert.notificationType === 'ComingSoon')
    )
  }
)
